module.exports = __webpack_public_path__ + "img/stopwatch.d7e975bb.svg";